var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4583 4.25004C27.4583 2.29433 25.8724 0.708374 23.9167 0.708374C19.0107 0.708374 8.98924 0.708374 4.08332 0.708374C2.12762 0.708374 0.541656 2.29433 0.541656 4.25004V29.75C0.541656 31.7058 2.12762 33.2917 4.08332 33.2917H23.9167C25.8724 33.2917 27.4583 31.7058 27.4583 29.75V4.25004ZM26.0417 4.25004V29.75C26.0417 30.9237 25.0904 31.875 23.9167 31.875H4.08332C2.90962 31.875 1.95832 30.9237 1.95832 29.75C1.95832 23.8234 1.95832 10.1767 1.95832 4.25004C1.95832 3.07633 2.90962 2.12504 4.08332 2.12504H23.9167C25.0904 2.12504 26.0417 3.07633 26.0417 4.25004Z",
    fill: "#C70048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91666 6.375C5.74366 6.375 4.79166 7.327 4.79166 8.5C4.79166 9.673 5.74366 10.625 6.91666 10.625C8.08966 10.625 9.04166 9.673 9.04166 8.5C9.04166 7.327 8.08966 6.375 6.91666 6.375ZM6.91666 7.79167C7.30766 7.79167 7.62499 8.109 7.62499 8.5C7.62499 8.891 7.30766 9.20833 6.91666 9.20833C6.52566 9.20833 6.20832 8.891 6.20832 8.5C6.20832 8.109 6.52566 7.79167 6.91666 7.79167Z",
    fill: "#C70048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91666 14.875C5.74366 14.875 4.79166 15.827 4.79166 17C4.79166 18.173 5.74366 19.125 6.91666 19.125C8.08966 19.125 9.04166 18.173 9.04166 17C9.04166 15.827 8.08966 14.875 6.91666 14.875ZM6.91666 16.2917C7.30766 16.2917 7.62499 16.609 7.62499 17C7.62499 17.391 7.30766 17.7083 6.91666 17.7083C6.52566 17.7083 6.20832 17.391 6.20832 17C6.20832 16.609 6.52566 16.2917 6.91666 16.2917Z",
    fill: "#C70048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91666 23.375C5.74366 23.375 4.79166 24.327 4.79166 25.5C4.79166 26.673 5.74366 27.625 6.91666 27.625C8.08966 27.625 9.04166 26.673 9.04166 25.5C9.04166 24.327 8.08966 23.375 6.91666 23.375ZM6.91666 24.7917C7.30766 24.7917 7.62499 25.109 7.62499 25.5C7.62499 25.891 7.30766 26.2083 6.91666 26.2083C6.52566 26.2083 6.20832 25.891 6.20832 25.5C6.20832 25.109 6.52566 24.7917 6.91666 24.7917Z",
    fill: "#C70048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 7.79167H22.5C22.891 7.79167 23.2083 7.47433 23.2083 7.08333C23.2083 6.69233 22.891 6.375 22.5 6.375H11.1667C10.7757 6.375 10.4583 6.69233 10.4583 7.08333C10.4583 7.47433 10.7757 7.79167 11.1667 7.79167Z",
    fill: "#C70048"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 16.2917H22.5C22.891 16.2917 23.2083 15.9743 23.2083 15.5833C23.2083 15.1923 22.891 14.875 22.5 14.875H11.1667C10.7757 14.875 10.4583 15.1923 10.4583 15.5833C10.4583 15.9743 10.7757 16.2917 11.1667 16.2917Z",
    fill: "#C70048"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 24.7917H22.5C22.891 24.7917 23.2083 24.4743 23.2083 24.0833C23.2083 23.6923 22.891 23.375 22.5 23.375H11.1667C10.7757 23.375 10.4583 23.6923 10.4583 24.0833C10.4583 24.4743 10.7757 24.7917 11.1667 24.7917Z",
    fill: "#C70048"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 10.625H18.25C18.641 10.625 18.9583 10.3077 18.9583 9.91671C18.9583 9.52571 18.641 9.20837 18.25 9.20837H11.1667C10.7757 9.20837 10.4583 9.52571 10.4583 9.91671C10.4583 10.3077 10.7757 10.625 11.1667 10.625Z",
    fill: "#C70048"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 19.125H18.25C18.641 19.125 18.9583 18.8077 18.9583 18.4167C18.9583 18.0257 18.641 17.7084 18.25 17.7084H11.1667C10.7757 17.7084 10.4583 18.0257 10.4583 18.4167C10.4583 18.8077 10.7757 19.125 11.1667 19.125Z",
    fill: "#C70048"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 27.625H18.25C18.641 27.625 18.9583 27.3077 18.9583 26.9167C18.9583 26.5257 18.641 26.2084 18.25 26.2084H11.1667C10.7757 26.2084 10.4583 26.5257 10.4583 26.9167C10.4583 27.3077 10.7757 27.625 11.1667 27.625Z",
    fill: "#C70048"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 9.20837H21.0833C20.6923 9.20837 20.375 9.52571 20.375 9.91671C20.375 10.3077 20.6923 10.625 21.0833 10.625H22.5C22.891 10.625 23.2083 10.3077 23.2083 9.91671C23.2083 9.52571 22.891 9.20837 22.5 9.20837Z",
    fill: "#C70048"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 17.7084H21.0833C20.6923 17.7084 20.375 18.0257 20.375 18.4167C20.375 18.8077 20.6923 19.125 21.0833 19.125H22.5C22.891 19.125 23.2083 18.8077 23.2083 18.4167C23.2083 18.0257 22.891 17.7084 22.5 17.7084Z",
    fill: "#C70048"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 26.2084H21.0833C20.6923 26.2084 20.375 26.5257 20.375 26.9167C20.375 27.3077 20.6923 27.625 21.0833 27.625H22.5C22.891 27.625 23.2083 27.3077 23.2083 26.9167C23.2083 26.5257 22.891 26.2084 22.5 26.2084Z",
    fill: "#C70048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.635690c5c57a7b5a0b4ffc472ec438ea.svg";
export { ForwardRef as ReactComponent };